import React from 'react'
import { FiltersLoader } from './FiltersLoader'
import { RegisteredLoad } from './RegisteredLoad'

const TournamentMembers = ({ tournament }): React.ReactElement => {
  if (tournament === undefined) {
    return (
      <FiltersLoader />
    )
  }

  return (
    <RegisteredLoad tournament={tournament} />
  )
}

export default TournamentMembers
